<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Purchasing    </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/msupplier/index"> Manage Supplier</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> {{ alldata.sup_name }}  </h6>
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->

                <div class="container-fluid" >


                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       

                  <button  @click="Update()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                 
            
                </div>

                <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                  <div >



                <div class="card custom_bdr_rds shadow p-2">
                <div class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>ID </b></td>
                           <td>{{ alldata.id_supplier }}</td> 
                          </tr>
                          <tr>
                            <td><b>Supplier Reference</b></td>
                           <td>{{ alldata.sup_reference }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Supplier Name</b></td>
                           <td>{{ alldata.sup_name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Supplier Address Line 1 </b></td>
                           <td>{{ alldata.sup_address_1 }}</td> 
                          </tr>
                          <tr>
                            <td><b>Supplier Address Line 2</b></td>
                           <td>{{ alldata.sup_address_2 }}</td> 
                          </tr>
                          <tr>
                            <td><b>Supplier Address Line 3 </b></td>
                           <td>{{ alldata.sup_address_3 }}</td> 
                          </tr>
                          <tr>
                            <td><b>Supplier Address Line 4 </b></td>
                           <td>{{ alldata.sup_address_4 }}</td> 
                          </tr>
                          <tr>
                            <td><b>Supplier Contact </b></td>
                           <td>{{ alldata.sup_contact }}</td> 
                          </tr>
                          <tr>
                            <td><b>Tel.</b></td>
                           <td>{{ alldata.tel }}</td> 
                          </tr>
                          <tr>
                            <td><b>Email</b></td>
                           <td>{{ alldata.email }}</td> 
                          </tr>
                          <tr>
                            <td><b>City</b></td>
                           <td>{{ alldata.city }}</td> 
                          </tr>
                          <tr>
                            <td><b>Currency</b></td>
                           <td>{{ alldata.relatedToCurrency.discription }}</td> 
                          </tr>
                          <tr>
                            <td><b>Country</b></td>
                           <td>{{ alldata.country }}</td> 
                          </tr>
                          <tr>
                            <td><b>Special Notes</b></td>
                           <td>{{ alldata.special_notes }}</td> 
                          </tr>
                          <tr>
                            <td><b>Status</b></td>
                           <td>{{ alldata.relatedToStatus.status }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created Date</b></td>
                           <td>{{ alldata.created_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created By</b></td>
                           <td>{{ alldata.relatedToUser.username }}</td> 
                          </tr>
                         
                           
                        </tbody>
                 
                 
                      </table>

                </div>
                </div>



                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                               <div class="table-responsive"> 
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(contact, index) in contacts" :key="contact.id">
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>

                          </div>


                        </div>
                    </div>


                    <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>CRM Notes</b></h6>

                     <div class="table-responsive"> 
              <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                  <thead class="background_color2" >
                    <tr class="custom-label2">
                    <th>#</th>
                    <th>Comment</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="(mservicelog, index) in mservicelogs" :key="mservicelog.idServicelog">
                    <td>{{index+1}}</td>
                    <td>{{ mservicelog.comments }}</td>
                    <td>{{ mservicelog.job_type }}</td>
                    <td>{{ mservicelog.created_date }}</td>
                    <td>{{ mservicelog.relatedToUser.username }}</td>
                    <td>{{ mservicelog.followup_date }}</td>
                    <td>{{ mservicelog.relatedToFollowupby.username }}</td>
                  
                    
                    </tr>
                  </tbody>

                </table>
</div>

          <br>
              

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3" v-model="crm.comments"  style="font-size: small;" class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select " v-model="crm.job_type">
                              <option  selected>Select....</option>
                              <option >Vehicle Sales</option>
                              <option  >Spare Parts Sales</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input v-model="crm.followup_date" type="date"  style="font-size: small;" class="form-control" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input v-model="username"  style="font-size: small;" class="form-control" disabled>
                    </div>
                  </div>


                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button @click="crmCreate()"  class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Save</button>
                </div>
                </div>

            </div>
        </div>



   

<br><br>





                




                </div>
                </div>
           
            </div>
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
   
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadAlldata()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            username:authService.isUsername(),
            total:{},
            'id':this.$route.query.id,
            customers:{},
            alldata:{},
            category:{},
            brand:{},
            supplier:{},
            status:{},
            crm:{},
            user:{},
            contacts:[],
            mservicelogs:[],
            trans:[],
     
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          
          async Update(){
        this.$router.push('/msupplier/update?id='+this.id);
      },

      async crmCreate() {
       
    
       try {
         const { data} = await  axios.post('/msupplier/crmcreate?id='+this.id,{crm:this.crm,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadAlldata();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },


            async loadAlldata() {
        console.log("Amila");
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/msupplier/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.alldata = data.item_list,
         this.mservicelogs =data.mservicelogs;
        
        
      } catch (error) {
        console.log(error.response);
      }
    },

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>